import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { generateGuid } from 'utils/guid';
import type { FormSettingsValues } from '../GraphSidePanel/GraphProtocolsSettingsWindow/GraphProtocolsSettings';

export interface AddEdgeGroupCommand {
  values: FormSettingsValues;
}

export const addEdgeGroup: GraphCommandFactory<AddEdgeGroupCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const { presetDraft } = draft.layoutSettings;
      presetDraft.edges.unshift({
        id: generateGuid(),
        name: command.values.name as string,
        type: 'group',
        grouped: false,
        label: command.values.label as string,
        style: {
          color: command.values.color,
          pattern: command.values.pattern,
          thicknessThresholds: [
            command.values.lineThicknessThin,
            command.values.lineThicknessMedium,
            command.values.lineThicknessThick,
          ],
        },
        children: [],
        visible: true,
      });
    });
  };
